var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 39,
    viewBox: "0 0 36 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1745 33.1671C5.38697 28.9419 1.16019 25.324 5.06141 18.6018C7.11305 15.0666 12.9579 8.13751 18.4159 5.98603C22.8602 3.00608 27.0323 6.50913 29.6387 8.00622C35.1364 11.1639 31.6744 19.0231 27.7732 25.7453C23.872 32.4676 15.6722 36.3248 10.1745 33.1671Z",
    fill: "#EF533F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2334 20.7613C14.2233 22.0743 16.335 24.6347 16.8629 24.3721C17.5228 24.0439 21.1524 18.7918 23.1321 17.4788",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.6bc504d68876959dedf2e0e4c9ab00a6.svg";
export { ForwardRef as ReactComponent };